import React from 'react';

// Styles & Assets
import styles from './FrequencySelector.module.css';

// Services
import { getCustomFrequencyFromPollFrequency } from '../../../services/Poll';

// Hooks
import { useState } from 'react';

// Components
import CancelConfirmButtons from '../CancelConfirmButtons/CancelConfirmButtons';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import FormFrequency from './FormFrequency/FormFrequency';

// Interfaces
import { CustomFrequency, PollFrequency } from '../../../interfaces/Poll';

// Language
import { useTranslation } from 'react-i18next';

// Constants
import { DEFAULT_DAILY_FREQ, DEFAULT_WEEKLY_FREQ, DEFAULT_MONTHLY_FREQ  } from '../../../data/ConstantsPolls';

interface Props {
    frequency: PollFrequency
    startEndDate?: boolean
    onCancel: () => void
    onConfirm: (freq: PollFrequency) => void
    setShow: React.Dispatch<React.SetStateAction<boolean>>
}

const FrequencySelector: React.FC<Props> = ({ frequency, startEndDate, onCancel, onConfirm, setShow }) => {

    const { t } = useTranslation();

    const [selectedFreq, setSelectedFreq] = useState<CustomFrequency>(getCustomFrequencyFromPollFrequency(frequency));
    const [temporaryFreq, setTemporaryFreq] = useState<PollFrequency>(frequency);

    const handleClickFrequency = (freq: CustomFrequency) => {
        if (freq === 'daily') setTemporaryFreq(DEFAULT_DAILY_FREQ);
        if (freq === 'weekly') setTemporaryFreq(DEFAULT_WEEKLY_FREQ);
        if (freq === 'monthly') setTemporaryFreq(DEFAULT_MONTHLY_FREQ);
        // if (freq === 'annual') setTemporaryFreq(DEFAULT_ANNUAL_FREQ);
        setSelectedFreq(freq);
    };

    const handleConfirm = () => {
        onConfirm(temporaryFreq);
        setShow(false);
    };


    return (
        <div className={`${styles.dialogFrequency} dialog`}>
            <h1 className={`${styles.title} dialogTitle`}>{t('custom_frequency')}</h1>
            <div className={styles.contentContainer}>
                <div className={styles.frequencySelectorContainer}>
                    <FormFrequency
                        selectedFreq={selectedFreq}
                        handleClickFrequency={handleClickFrequency}
                        temporaryFreq={temporaryFreq}
                        setTemporaryFreq={setTemporaryFreq}
                    />
                </div>
                {/* { startEndDate ? 
                    <div className={styles.datesContainer}>
                        <div>
                            <h3 className={styles.subtitle}>{t('start_date')}</h3>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker disabled className={styles.calendar} />
                            </LocalizationProvider>
                        </div>
                        <div>
                            <h3 className={styles.subtitle}>{t('end_date')}</h3>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker disabled className={styles.calendar} />
                            </LocalizationProvider>
                        </div>
                    </div>
                    : null
                } */}
            </div>
            <CancelConfirmButtons
                onCancel={onCancel}
                onConfirm={handleConfirm}
            />
        </div>
    );
};

export default FrequencySelector;